<template>
  <div class="zj-emergency-person-schedule">
    <div class="zj-emergency-person-search-box">
      <input
        class="zj-emergency-person-search-box-input"
        v-model="searchText"
        type="text"
        placeholder="请输入姓名"
      />
      <div class="zj-emergency-person-search-box-btn" v-on:click="searchconcat"></div> 
    </div>
    <el-tabs class="person-tabs custom-tabs" v-model="activeTab">
      <el-tab-pane
        :key="item.name"
        v-for="(item) in personOrgianiztionType"
        :label="item.Extend1"
        :name="item.ItemKey"
      >
        <UserOrgControl :roomId="roomId" :pwd="pwd"  v-bind:ExecutId="ExecutId" :PersonName="searchText" :ResourceTypeId="item.ItemKey" :ref="item.ItemKey"></UserOrgControl>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import UserOrgControl from "./Component-UserOrgControl";
export default {
  props: {
    ExecutId: {
      type: String,
      required: true
    },
    roomId: {
      type: String
    },
    pwd: {
      type: String
    }
  },
  components: {
    UserOrgControl
  },
  data() {
    return {
      ruleForm: {},
      personOrgianiztionType: [], // 人员类型
      activeTab: "",
      searchText:""
    };
  },
  created: function() {
    let that = this;
    this.config
      .getUValue("EmergencyService:PersonOrgianiztionType:", "")
      .then(d => {
        if (d.JValue && d.JValue.length > 0) {
          that.personOrgianiztionType = d.JValue;
          that.activeTab = d.JValue[0].ItemKey;

          //that.loadOrg(that.activeTab);
        }
      })
      .catch(e => {
        console.error(e);
      });
  },
  methods:{
    searchconcat:function(){

    }
  }
};
</script>